import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";

const DeleteSupplierDialog = ({ supplier, onCancel, onConfirm }) => (
    <Dialog open={Boolean(supplier)} onClose={onCancel}>
        <DialogTitle>Lieferant löschen?</DialogTitle>
        <DialogContent>
            <Typography>
                Möchtest du den Lieferanten "{supplier?.name}" wirklich löschen? Bereits erfasste Belege behalten den Namen.
            </Typography>
        </DialogContent>
        <DialogActions>
            <Button onClick={onCancel}>Abbrechen</Button>
            <Button color="error" onClick={onConfirm}>
                Löschen
            </Button>
        </DialogActions>
    </Dialog>
);

export default DeleteSupplierDialog;
